import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToastController } from 'smoothie';

import {
    MutationErrorToastOptions,
    MutationSuccessToastOptions,
} from '../../common/components/Toasts';
import { llmServiceFetcher } from '../LlmServiceFetcher';

interface StartExperimentResponse {
    started: boolean;
    experimentId: string;
}

export const useStartExperiment = (agentId: string) => {
    const queryClient = useQueryClient();
    const toast = useToastController();

    return useMutation({
        mutationFn: async (
            targetAgentKey: string,
        ): Promise<StartExperimentResponse> => {
            return await llmServiceFetcher<StartExperimentResponse>({
                endpoint: `/agents/${encodeURIComponent(agentId)}/dataset/experiments`,
                method: 'POST',
                body: JSON.stringify({ targetAgentKey }),
            });
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: ['dataset', agentId],
            });
            void queryClient.invalidateQueries({
                queryKey: ['experiments', agentId],
            });

            toast.show('Experiment started.', MutationSuccessToastOptions);
        },
        onError: (error) => {
            toast.show(
                'Failed to start the experiment.',
                MutationErrorToastOptions(error.message),
            );
        },
    });
};
